/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */

const roles = (id: string): string => `/roles/${id}`;
const groups = (id: string): string => `/groups/${id}`;

export const PortalRbacApiEnum = {
    GET_ROUTES_CURRENT_USER: '/endpoints/access',
    GET_ROUTES_ENDPOINTS: '/endpoints/',
    GET_RBAC_ROLES: '/roles/',
    GET_RBAC_ROLE: roles,
    POST_RBAC_ROLE: '/roles/',
    PATCH_USER_TO_ROLE: (id: string): string => {
        return `/roles/${id}/accounts/add`;
    },
    DELETE_RBAC_ROLE: roles,
    PATCH_RBAC_ROLE: roles,
    GET_RBAC_GROUPS: '/groups/',
    GET_RBAC_GROUP: groups,
    POST_RBAC_GROUP: '/groups/',
    PATCH_RBAC_GROUP: groups,
    DELETE_RBAC_GROUP: groups
};
